import { StaticImage } from "gatsby-plugin-image"

import { Heading, Icon } from "@trueskin-web/components"

import chatIcon from "../images/chat-icon.svg"
import clipboardIcon from "../images/clipboard-icon.svg"
import packageIcon from "../images/package-icon.svg"
import sparklesIcon from "../images/sparkles-icon.svg"
import usersIcon from "../images/users-icon.svg"

const FEATURES = [
  {
    icon: clipboardIcon,
    label: "Diagnose + Behandlungsplan in 24h",
    iconWidth: 15,
    iconHeight: 22,
  },
  {
    icon: packageIcon,
    label: "Versand nach Hause in 3–5 Tagen",
    iconWidth: 17,
    iconHeight: 22,
  },
  {
    icon: usersIcon,
    label: "Monatliche Begutachtung Deines Fortschritts",
    iconWidth: 23,
    iconHeight: 22,
  },
  {
    icon: chatIcon,
    label: "Unbegrenzte ärztliche Beratung",
    iconWidth: 18,
    iconHeight: 22,
  },
  {
    icon: sparklesIcon,
    label: "Jederzeit pausieren, schieben oder kündigen",
    iconWidth: 15,
    iconHeight: 22,
  },
]

function FeaturesCard() {
  return (
    <div
      sx={{
        width: ["100vw", "100%"],
        position: "relative",
        left: ["50%", 0],
        mr: [null, "auto"],
        ml: ["-50vw", 0],
        bg: "#1A1C2B",
        borderRadius: "32px",
        overflow: "hidden",
        pt: 6,
        px: 5,
        pb: 6,
        mb: 4,
        color: "#FFF",
      }}
    >
      <Heading as="h3" sx={{ lineHeight: 1.333, fontWeight: "bold", mb: 6 }}>
        Endlich jünger aussehen dank individueller Anti-Aging-Pflege
      </Heading>

      <ul sx={{ listStyle: "none", m: 0, p: 0 }}>
        {FEATURES.map((feat, i) => (
          <li
            key={feat.label}
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 3,
              mb: i < FEATURES.length - 1 ? 4 : 0,
            }}
          >
            <div
              sx={{
                width: 35,
                height: 35,
                bg: "#3A3D4F",
                p: "5px 8px",
                borderRadius: "8px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Icon
                icon={feat.icon}
                color="#FFF"
                sx={{ width: feat.iconWidth, height: feat.iconHeight }}
              />
            </div>

            <p sx={{ fontSize: 1, lineHeight: 1.428, color: "#F6F6F6", m: 0 }}>
              {feat.label}
            </p>
          </li>
        ))}
      </ul>

      <div
        sx={{
          mt: 6,
          bg: "#3A3D4F",
          borderRadius: "8px",
          p: 4,
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
        }}
      >
        <p
          sx={{
            color: "#F6F6F6",
            fontSize: 1,
            fontWeight: "bold",
            mb: 2,
            mt: 0,
          }}
        >
          In Zusammenarbeit mit
        </p>

        <StaticImage
          src="../images/apotheker-logo.webp"
          alt="Ärzten-apotheker"
          width={89}
          height={42.771}
        />
      </div>
    </div>
  )
}

export default FeaturesCard
